<template>
  <div>
    <v-app-bar id="navBarComponent" v-resize="onResize" :height="heightNav" app flat>
      <div class="row no-gutters align-items-center d-none d-sm-flex home-desktop-nav">
        <div class="col-8 ">
          <div class="row align-items-center no-gutters">
            <div class="col-3 ">
              <img
                  alt="لوگوی ایوان خانه"
                  class="img-fluid"
                  src="../assets/img/logo.png"
              />
            </div>
            <div class="col-auto">
              <router-link :class="active === 'home' ? 'router-link-active':''" to="Home">
                <i class="fa-regular fa-house font16px pl-2"></i>
                <span class="font12px">HOME</span>
              </router-link>

            </div>
            <div class="col-auto">
              <router-link :class="active === 'offline' ? 'router-link-active':''" class="mr-3"
                           to="OfflinePaymentHome">
                <i class="fa-regular fa-store font16px pl-2"></i>
                <span class="font12px">OFFLINEPAY</span>
              </router-link>
            </div>
            <div class="col-auto">
              <router-link :class="active === 'online' ? 'router-link-active':''" class="mr-3" to="OnlinePaymentHome">
                <i class="fa-regular fa-store font16px pl-2"></i>
                <span class="font12px">ONLINEPAY</span>
              </router-link>
            </div>
            <div class="col-auto">
              <router-link :class="active === 'search' ? 'router-link-active':''" class="mr-3" to="SearchTags">
                <i class="fa-regular fa-search font16px pl-2"></i>
                <span class="font12px">SEARCH</span>
              </router-link>
            </div>
          </div>
        </div>
        <div class="col-4 text-left">
        <span class="ml-2">
          <span class="black-left-border px-3">
              <router-link v-if="isLoggedIn && isSeller" to="SellerProfile">
                <i class="fa-regular fa-user font16px  transform-icon px-2"></i>
                <span>پروفایل</span>
              </router-link>
              <router-link v-else-if="isLoggedIn && isBuyer" to="BuyerProfile">
                <i class="fa-regular fa-user font16px  transform-icon px-2"></i>
                <span>پروفایل</span>
              </router-link>
            <router-link v-else to="LoginRegister">
                <i class="fa-regular fa-user font16px  transform-icon px-2"></i>
                <span>ورود /ثبت نام</span>
              </router-link>
          </span>

             <router-link v-if="isLoggedIn && isBuyer" to="Cart">
              <v-btn class="mr-2" icon to="Cart">
                <v-badge
                    :content="orderNumber"
                    bordered>
               <i class="fa-regular fa-shopping-cart font16px black--text"></i>
                 </v-badge></v-btn>
             </router-link>
                <span v-else-if="isLoggedIn && isSeller" class="pointer" @click="showSellerSnackBar">
              <v-btn class="mr-2" icon>
               <i class="fa-regular fa-shopping-cart font16px black--text"></i></v-btn>
             </span>
                <span v-else-if="!isLoggedIn" @click="showNotLoggedInSnackBar">
              <v-btn class="mr-2" icon>
               <i class="fa-regular fa-shopping-cart font16px black--text"></i></v-btn>
             </span>


        </span>
        </div>

      </div>
      <div class="row no-gutters align-items-center d-flex d-sm-none">
        <div class="col-6">
          <v-btn icon @click="drawer = !drawer"><i class="fa-regular fa-align-right font19px fa-flip-vertical"></i>
          </v-btn>
          <v-btn icon to="SearchTags"><i class="fa-regular fa-search font19px "></i></v-btn>
        </div>
        <div class="col-6 text-left">
          <img
              alt="لوگوی ایوان خانه"
              height="40"
              src="../assets/img/logo.png"
          />
        </div>
        <div class="col-12 mt-3 gradient-bg rounded-lg mobile-nav">
          <div class="row mx-1 align-items-center py-1">
            <div class="col text-center mobile-nav-div ">
              <router-link v-if="isLoggedIn && isBuyer" to="Cart">
                <v-badge
                    :content="orderNumber"
                    bordered
                    bottom>
                  <i class="font19px fa-regular fa-cart-shopping"></i>
                  <div id="cartBadge">CART</div>
                </v-badge>
              </router-link>
              <span v-else-if="isLoggedIn && isSeller" class="pointer" @click="showSellerSnackBar">
                <i class="font19px fa-regular fa-cart-shopping"></i>
              </span>
              <span v-else-if="!isLoggedIn" @click="showNotLoggedInSnackBar">
                <i class="font19px fa-regular fa-cart-shopping primary-text"></i>
              </span>
            </div>
            <div class="col text-center   mobile-nav-div">
              <router-link :class="active === 'offline' ? 'router-link-active':''" to="OfflinePaymentHome">
                <i class="fa-regular fa-store font19px"></i>
                <div>OFFLINEPAY</div>
              </router-link>
            </div>
            <div class="col text-center mobile-nav-div">
              <router-link :class="active === 'home' ? 'router-link-active':''" to="Home">
                <i class="fa-regular fa-house font19px"></i>
                <div>HOME</div>
              </router-link>
            </div>
            <div class="col text-center   mobile-nav-div">
              <router-link :class="active === 'online' ? 'router-link-active':''" class="" to="OnlinePaymentHome">
                <i class="fa-regular fa-store font19px"></i>
                <div>ONLINEPAY</div>
              </router-link>
            </div>
            <div class="col text-center mobile-nav-div">
              <router-link v-if="isLoggedIn && isSeller" to="SellerProfile">
                <i class="font19px fa-regular fa-user"></i>
                <div>PROFILE</div>
              </router-link>
              <router-link v-else-if="isLoggedIn && isBuyer" to="BuyerProfile">
                <i class="font19px fa-regular fa-user"></i>
                <div>PROFILE</div>
              </router-link>
              <router-link v-else to="LoginRegister">
                <i class="font19px fa-regular fa-user"></i>
                <div>LOGIN</div>
              </router-link>
            </div>
          </div>
        </div>
      </div>


    </v-app-bar>
    <v-navigation-drawer v-model="drawer" fixed   style="height:100vh !important;" right>
      <v-btn icon @click="drawer=false">
        <i class="fa-solid fa-circle-xmark fa-xl"></i>
      </v-btn>
      <div class="row mx-2 light-gray-bg  rounded-lg ">
        <div class="col-4 "><i class="fa-regular fa-align-right font19px fa-flip-vertical"></i></div>
        <div class="col-8 font16px">ایوان خانه</div>
      </div>
      <v-list dense>
        <v-list-item-group
            v-model="group"
            active-class="text--accent-4">
          <v-list-item v-for="item in navItems" :key="item.id"  class="pl-1 my-3">
            <v-list-item-icon class="ml-1">
              <router-link v-if="!item.needLogin" :to="item.path"><i :class="item.icon" class=""></i></router-link>
              <span v-else @click="goTo(item.path)"><i :class="item.icon" class=""></i></span>
            </v-list-item-icon>
            <v-list-item-title>

              <router-link v-if="!item.needLogin" :to="item.path">{{ item.text }}</router-link>
              <span v-else @click="goTo(item.path)">{{ item.text }}</span>
            </v-list-item-title>
            <v-list-item-icon class="mx-0 pt-1">
              <router-link v-if="!item.needLogin" :to="item.path"><i class="fa-solid fa-arrow-left font16px transform-icon"></i></router-link>
              <span v-else @click="goTo(item.path)" ><i class="fa-solid fa-arrow-left font16px transform-icon"></i></span>
            </v-list-item-icon>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-snackbar
        v-model="showResult"
        :multi-line="true"
        color="primary"    >
      <div v-html="resultText"></div>

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="showResult = false ">
          <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  props: ['active'],
  data: () => ({
    showResult: false,
    resultText: '',
    orderNumber: 1,
    searchKeyWord: null,
    drawer: false,
    group: null,
    navItems: [
      {
        id: 1,
        text: "درباره ما",
        icon: "fa-regular fa-circle-info fa-xl",
        path: "AboutUs",
        needLogin:false
      },
      {
        id: 2,
        text: "تماس با ما",
        icon: "fa-regular fa-phone fa-xl",
        path: "ConnectUs",
        needLogin:false
      },
      {
        id: 3,
        text: "قوانین مقررات و حریم خصوصی",
        icon: "fa-regular fa-lock-keyhole fa-xl",
        path: "RulesOfRegulation",
        needLogin:false
      },
      {
        id: 5,
        text: "انتقادات و پیشنهادات",
        icon: "fa-regular fa-comment-captions fa-xl",
        path: "CriticsAndSuggestions",
        needLogin:true
      },
      {
        id: 6,
        text: "سوالات متداول",
        icon: "fa-regular fa-circle-question fa-xl",
        path: "FAQ",
        needLogin:false
      },
      {
        id: 7,
        text: "پشتیبانی",
        icon: "fa-regular fa-headset fa-xl",
        path: "Support",
        needLogin:false
      }
    ],
    windowSize: {
      x: 0,
      y: 0,
    },
    heightNav: 100,
    isLoggedIn: false,
    isSeller: false,
    isBuyer: false,

  }),
  mounted() {
    this.onResize()
    this.silentLogin()
    this.orderNumber = this.$store.getters.getOrderCount

  },
  watch: {
    '$store.getters.getOrderCount'() {
      this.orderNumber = this.$store.getters.getOrderCount
    }
  },

  methods: {
    silentLogin() {
      let userDate = this.$getUserData()
      if (userDate.mobile !== undefined && userDate.mobile !== null && userDate.mobile !== '' && userDate.activeCode !== undefined && userDate.activeCode !== null && userDate.activeCode !== '') {
        let myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        let urlencoded = new URLSearchParams();
        urlencoded.append("PhoneNumber", userDate.mobile);
        urlencoded.append("Password", userDate.activeCode);

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };
        let resStatus = null;
        fetch(this.$baseUrl + "Home/Login", requestOptions)
            .then(response => {
              resStatus = response.status
              return response.text()
            })
            .then(result => {

              if (resStatus === 200) {
                let json = JSON.parse(result)
                this.$setUserData(userDate.mobile, userDate.activeCode, 'Bearer ' + json.JwtToken, json.Role);
                this.$store.commit('setToken', 'Bearer ' + json.JwtToken)
                this.$store.commit('setRole', json.Role)
                this.$store.commit('setIsLoggedIn', true)
                this.$store.commit('addProductToCart')


                if (json.Role === 4) {
                  // this.getClientLikeList();
                  this.isBuyer = true
                } else if (json.Role === 3) {
                  this.isSeller = true
                }
                this.isLoggedIn = true
              } else {
                this.isLoggedIn = false
                this.isSeller = false
                this.isBuyer = false
                this.$store.commit('setIsLoggedIn', false)

              }
            })
            .catch(error => console.log('error', error));
      } else {
        this.isLoggedIn = false
        this.isSeller = false
        this.isBuyer = false
        this.$store.commit('setIsLoggedIn', false)

      }
    },
    onResize() {
      this.windowSize = {x: window.innerWidth, y: window.innerHeight}
      if (this.windowSize.x >= 768) {
        this.heightNav = 50
      } else if (this.windowSize.x >= 550) {
        this.heightNav = 120
      } else {
        this.heightNav = 120
      }
    },
    search(e) {
      if (e.keyCode === 13) {
        this.searchBtn();
      }
    },
    searchBtn() {
      this.$router.replace({
        path: "ListAdvertisement",
        query: {KeyWord: this.searchKeyWord}
      });
      this.overlay = false;
    },
    showNotLoggedInSnackBar() {
      this.resultText = 'برای مشاهده این بخش باید وارد شوید'
      this.showResult = true

    },
    showSellerSnackBar() {
      this.resultText = 'برای فروشنده ها امکان خرید وجود ندارد'
      this.showResult = true
    },
    goTo(path){
      if(this.isLoggedIn ===true){
        this.$router.push({path:path})
      }else {
        this.resultText='برای مشاهده این بخش باید وارد شوید'
        this.showResult=true
      }
    }

  }
};
</script>

<style scoped></style>
